import { useState, useEffect, useRef } from 'react';
import { Heading, Text } from '../../atoms';
import { ServiceCard } from '../../molecules';
import { useLanguage } from '../../../context/LanguageContext';
import './ServicesSection.css';

const SERVICE_KEYS = ['amparos', 'derechos', 'sucesiones', 'familyLaw', 'ciudadania'];
const SERVICE_ICONS = { amparos: '⚖️', derechos: '👤', sucesiones: '📜', familyLaw: '👨‍👩‍👧‍👦', ciudadania: '🪪' };

function ServicesSection() {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(() => {
    if (typeof window === 'undefined') return true;
    return window.innerWidth < 768;
  });
  const sectionRef = useRef(null);

  useEffect(() => {
    if (isVisible) return;
    const el = sectionRef.current;
    if (!el) return;
    if (typeof IntersectionObserver === 'undefined') {
      setIsVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [isVisible]);

  return (
    <section
      id="services"
      ref={sectionRef}
      className={`services-section ${isVisible ? 'services-section--visible' : ''}`}
    >
      <div className="services-section__inner">
        <span className="services-section__label">{t('services.label')}</span>
        <Heading level={2} className="services-section__title">{t('services.title')}</Heading>
        <Text size="large" className="services-section__intro">
          {t('services.intro')}
        </Text>
        <div className="services-section__grid">
          {SERVICE_KEYS.map((key) => (
            <ServiceCard
              key={key}
              title={t(`servicesList.${key}.title`)}
              description={t(`servicesList.${key}.description`)}
              icon={SERVICE_ICONS[key]}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
